<template>
  <a-modal
    v-model:visible="modalConfig.visible"
    :title="modalConfig.title"
    @ok="handleOk"
    @cancel="closeModal"
  >
    <a-form
      :model="formState"
      ref="formRef"
      :rules="rules"
      :labelCol="{
        span: 4,
      }"
    >
      <a-form-item label="描述" name="description" v-if="isEditAction">
        <a-textarea
          auto-size
          v-model:value="formState.description"
          placeholder="请输入描述、所需帮助、需求时间"
        ></a-textarea>
      </a-form-item>

      <a-form-item label="状态" name="scheduleStatus" v-if="showRelease">
        <a-select v-model:value="formState.scheduleStatus" placeholder="请选择状态">
          <a-select-option value="发布">发布</a-select-option>
          <a-select-option value="移至项目计划">移至项目计划</a-select-option>
          <a-select-option value="停止">停止</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="类型" name="softwareOrHardware" v-if="showRelease">
        <a-select
          v-model:value="formState.softwareOrHardware"
          placeholder="请选择类型"
        >
          <a-select-option value="software">软件</a-select-option>
          <a-select-option value="hardware">硬件</a-select-option>
        </a-select>
      </a-form-item>
      <!-- 处理人 -->
      <a-form-item
        :label="showRelease ? '计划人' : '处理人'"
        name="executor"
        v-if="showRelease || showScheduled"
      >
        <!-- {{ route.query.projectLeader }} -->
        <staff
          v-if="modalConfig.visible"
          :echoStaff="showRelease ? formState.plannerId : formState.executorId"
          :echostaffUserName="
            showRelease ? formState.planner : formState.executor
          "
          @getChooseStaff="getChooseStaff"
        ></staff>
      </a-form-item>
      <!-- 预计时间 -->
      <a-form-item label="发布时间" name="release" v-if="showRelease">
        <a-range-picker
          v-model:value="releaseRangeDate"
          placeholder="请选择发布时间"
          @change="handleRangeDate($event, 'release')"
        />
      </a-form-item>
      <!-- 计划时间 -->
      <a-form-item label="计划时间" name="scheduled" v-if="showScheduled">
        <a-range-picker
          v-model:value="scheduledRangeDate"
          placeholder="请选择计划时间"
          @change="handleRangeDate($event, 'scheduled')"
        />
      </a-form-item>
      <!-- 实际处理时间 -->
      <a-form-item
        label="实际日期"
        name="actualRelease"
        v-if="showActualRelease"
      >
        <a-date-picker
          v-model:value="formState.actualReleaseStartTime"
          placeholder="请选择实际开始日期"
          @change="handleSelectActualReleaseTime"
        >
        </a-date-picker>
      </a-form-item>
      <a-form-item label="完成率" v-if="showActualRelease">
        <a-input-number
          v-model:value="formState.completionDegree"
          :step="1"
          :formatter="(value) => `${value}%`"
          :parser="(value) => value.replace('%', '')"
          placeholder="请输入完成率"
        ></a-input-number>
      </a-form-item>
      <a-form-item label="备注" v-if="showScheduled || showActualRelease">
        <a-textarea
          v-model:value="formState.assistanceNeeded"
          auto-size
        ></a-textarea>
      </a-form-item>

      <a-form-item
        label="问题确认"
        name="problemConfirm"
        v-if="modalConfig.type === '问题'"
      >
        <a-switch
          checked-children="是"
          un-checked-children="否"
          v-model:checked="formState.problemConfirm"
        />
      </a-form-item>
      <a-form-item label="工作记录" v-if="showActualRelease">
        <after-sale-qeustion-vue
          v-if="modalConfig.visible"
          :questionLists="formState.workRecords"
          noticeText="工作记录"
          ref="workRecordsRef"
          textAreaStyle="'width: 300px; margin-right: 8px; height: auto'"
        >
        </after-sale-qeustion-vue>
      </a-form-item>
      <!-- 文件 -->
      <a-form-item label="文件" v-if="isEditAction">
        <upload
          @setUploadFileUrl="setUploadFileUrl"
          :echoFile="formState.fileLink"
        ></upload>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
   
<script>
import { computed, defineComponent, reactive, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import {
  insertProblemRequirementSchedule,
  updateProblemRequirementSchedule,
} from "@/request/view/project";
import websocket from "@/utils/base/socket";
import { debounce, timeStampToTime, Toast } from "@/utils/index";
import upload from "@/views/rdmanagement/components/database/upload.vue";
import staff from "@/components/chooseStaff/staff.vue";
import afterSaleQeustionVue from "@/views/repair/components/afterSaleQeustion.vue";

export default defineComponent({
  components: { upload, staff, afterSaleQeustionVue },
  setup(props, context) {
    const route = useRoute();
    const user = useStore().state.user.user;
    // 模态框数据
    const modalConfig = reactive({
      visible: false,
      title: null,
      isInsert: false,
      type: null,
      step: null,
    });
    const workRecordsRef = ref();
    const showRelease = computed(() => modalConfig.step === "release");

    const showScheduled = computed(() => modalConfig.step === "scheduled");

    const showActualRelease = computed(
      () => modalConfig.step === "actualRelease"
    );

    const isEditAction = computed(
      () => modalConfig.step === "edit" || modalConfig.step === undefined
    );

    // 表单数据
    const formState = reactive({
      actualReleaseEndTime: null,
      actualReleaseStartTime: null,
      assistanceNeeded: null,
      completionDegree: null,
      description: null,
      executor: null,
      executorId: null,
      fileLink: null,
      id: null,
      planner: null,
      plannerId: null,
      scheduleStatus: null,
      problemConfirm: null,
      projectLifeCycle: null,
      projectLifeCycleId: null,
      releaseEndTime: null,
      releaseStartTime: null,
      scheduledEndTime: null,
      scheduledStartTime: null,
      softwareOrHardware: null,
      structureName: null,
      toUsers: null,
      type: null,
      userId: null,
      username: null,
      wbs: null,
      workRecords: null,
    });

    const checkRangeTime = (startKey, endKey) => {
      if (formState[startKey] !== null && formState[endKey] !== null) {
        return Promise.resolve();
      }
      return Promise.reject("请选择时间");
    };

    const checkRelease = async () => {
      return checkRangeTime("releaseStartTime", "releaseEndTime");
    };

    const checkScheduled = async () => {
      return checkRangeTime("scheduledStartTime", "scheduledEndTime");
    };

    const checkActualRelease = async () => {
      if (showActualRelease.value && formState.actualReleaseStartTime) {
        return Promise.resolve();
      }
      return Promise.reject("请选择实际时间");
    };

    const checkExecutor = async () => {
      if (showRelease.value && formState.plannerId) {
        return Promise.resolve();
      }

      if (showScheduled.value && formState.executorId) {
        return Promise.resolve();
      }

      return Promise.reject("请选择执行人");
    };
    // 校验规则
    const rules = {
      description: [
        {
          required: true,
          message: "请输入描述",
          trigger: "blur",
          type: "any",
        },
      ],
      scheduleStatus: [
        {
          required: true,
          message: "请选择状态",
          trigger: "blur",
          type: "any",
        },
      ],
      release: [
        {
          required: true,
          validator: checkRelease,
          trigger: "change",
        },
      ],
      scheduled: [
        {
          required: true,
          validator: checkScheduled,
          trigger: "change",
        },
      ],
      actualRelease: [
        {
          required: true,
          validator: checkActualRelease,
          trigger: "change",
        },
      ],
      executor: [
        {
          required: true,
          validator: checkExecutor,
          trigger: "change",
        },
      ],
      softwareOrHardware: [
        {
          required: true,
          message: "请选择类型",
          trigger: "blur",
          type: "any",
        },
      ],
    };
    // 表单
    const formRef = ref();
    // 重置表单
    const resetForm = () => {
      Object.keys(formState).forEach((key) => {
        formState[key] = null;
      });
      formRef.value.clearValidate();
    };
    const send = (content, toUserId, query) => {
      console.log(content, toUserId, query, "websocket send");
      

      if (user.id == toUserId) return;
      websocket.Send({
        content,
        query: JSON.stringify(query),
        route: "/rdprojectlayout",
        messageSort: modalConfig.type === "需求" ? "需求进度" : "问题进度",
        toUserId,
        type: 0,
        userId: user.id,
      });
    };
    // websocket通知
    const websocketNotice = () => {
      const query = Object.assign(
        {
          wbs: formState.wbs,
          activeKey: modalConfig.type === "需求" ? "需求进度" : "问题进度",
          type: "link",
        },
        route.query
      );

      const { nickName } = user;
      const localTime = timeStampToTime("", "upload");

      let toUserId = null;
      let content = `${nickName}在${localTime}推送${formState.description}; 任务状态:${formState.scheduleStatus}`;

      // 新增通知项目负责人
      if (modalConfig.isInsert) {
        toUserId = route.query.userId;
      }
      // 发布
      if (showRelease.value) {
        toUserId = formState.plannerId;
        // 计划
      } else if (showScheduled.value) {
        toUserId = formState.executorId;
        // 完成任务
      } else if (showActualRelease.value && formState.completionDegree == 100) {
        content = `${nickName}在${localTime}已完成${formState.description}`;
        send(content, route.query.userId, query);
        send(content, formState.userId, query);
        return;
      }

      if (showActualRelease.value && formState.completionDegree != 100) return;

      send(content, toUserId, query);
    };
    const getChooseStaff = (data) => {
      const { idList, staffUserName } = data;
      const chooseUsername = staffUserName[0];
      const chooseUserId = idList[0];
      if (showRelease.value) {
        formState.planner = chooseUsername;
        formState.plannerId = chooseUserId;
      } else if (showScheduled.value) {
        formState.executor = chooseUsername;
        formState.executorId = chooseUserId;
      }
    };

    // 设置
    const insertFormData = () => {
      const { projectAS, projectLifeCycle, projectId } = route.query;
      const recordType = modalConfig.type === "需求" ? "R" : "Q";
      const lifeCycle = projectLifeCycle.slice(0, 2);
      formState.projectLifeCycle = projectLifeCycle;
      formState.projectLifeCycleId = projectId;
      formState.wbs = `${projectAS}${lifeCycle}-${recordType}`;
      formState.structureName =
        user.secondaryDepartment || user.firstLevelDepartment;
      // formState.softwareOrHardware =
      //   formState.structureName.indexOf("软件") !== -1
      //     ? "software"
      //     : "hardware";
      formState.userId = user.id;
      formState.username = user.nickName;
    };

    // 时间范围值
    const releaseRangeDate = ref([]);
    const scheduledRangeDate = ref([]);
    const actualReleaseRangeDate = ref([]);

    const setRecordTime = (data) => {
      if (data.releaseStartTime && data.releaseEndTime) {
        releaseRangeDate.value.push(data.releaseStartTime, data.releaseEndTime);
      }

      if (data.scheduledStartTime && data.scheduledEndTime) {
        scheduledRangeDate.value.push(
          data.scheduledStartTime,
          data.scheduledEndTime
        );
      }

      if (data.actualReleaseStartTime && data.actualReleaseEndTime) {
        actualReleaseRangeDate.value.push(
          data.actualReleaseStartTime,
          data.actualReleaseEndTime
        );
      }
    };

    // 打开表单
    const showModal = (options) => {
      const { type, title, isInsert, data, step } = options;
      modalConfig.title = title;
      modalConfig.isInsert = isInsert;
      modalConfig.type = type;
      formState.type = type;
      modalConfig.visible = true;
      modalConfig.step = step;

      if (data) {
        Object.keys(formState).forEach((key) => {
          formState[key] = data[key];
        });
        setRecordTime(data);
      }
    };
    // 关闭表单
    const closeModal = () => {
      releaseRangeDate.value.length = 0;
      scheduledRangeDate.value.length = 0;
      actualReleaseRangeDate.value.length = 0;
      modalConfig.visible = false;
      modalConfig.title = "";
      modalConfig.isInsert = null;
      modalConfig.type = null;
      modalConfig.step = null;
      resetForm();
    };

    const handleSelectActualReleaseTime = (e, stringTime) => {
      formState.actualReleaseEndTime = stringTime;
    };
    const getOutPutResult = (componentRef, key) => {
      if (!componentRef) return;
      const result = JSON.stringify(componentRef.questionList);
      if (result && result !== "[]") {
        const textData = JSON.parse(result);
        textData.forEach((item) => {
          delete item.disabled;
          delete item.key;
        });
        formState[key] = JSON.stringify(textData);
      } else if (result === "[]") {
        formState[key] = null;
      }
    };
    // 提交表单
    const handleOk = debounce(() => {
      if (modalConfig.isInsert) insertFormData();
      getOutPutResult(workRecordsRef.value, "workRecords");
      formRef.value
        .validate()
        .then(() => {
          if (showActualRelease.value && formState.completionDegree) {
            formState.actualReleaseEndTime = timeStampToTime("", "upload");
          }
          const reqFn = modalConfig.isInsert
            ? insertProblemRequirementSchedule
            : updateProblemRequirementSchedule;
          reqFn(formState)
            .then((res) => {
              if (modalConfig.isInsert) {
                formState.wbs = res.data.wbs;
              }
              let type = res.code === 200 ? "success" : "warning";
              Toast(type, res.message, 3);
              websocketNotice();
              context.emit("updateTable");
              closeModal();
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          if (err.errorFields) {
            const [errors] = err.errorFields[0].errors;
            Toast("warning", errors, 3);
          }
        });
    });
    // 上传文件
    const setUploadFileUrl = (url) => {
      formState.fileLink = url;
    };

    // 选择时间范围
    const handleRangeDate = (date, type) => {
      const [sTime, eTime] = date;
      if (sTime === undefined) {
        formState[`${type}StartTime`] = null;
        formState[`${type}EndTime`] = null;
      } else {
        formState[`${type}StartTime`] = timeStampToTime(sTime._d, "upload");
        formState[`${type}EndTime`] = timeStampToTime(eTime._d, "upload");
      }
    };

    return {
      route,
      handleOk,
      showModal,
      closeModal,
      getChooseStaff,
      handleRangeDate,
      setUploadFileUrl,
      handleSelectActualReleaseTime,
      workRecordsRef,
      releaseRangeDate,
      scheduledRangeDate,
      actualReleaseRangeDate,
      modalConfig,
      formState,
      formRef,
      rules,
      isEditAction,
      showRelease,
      showScheduled,
      showActualRelease,
    };
  },
});
</script>
   
<style lang="less" scoped>
</style>